/**
 * Labeled onSnapshot wrappers with console error labels; used by session providers.
 */
import {
  type DocumentReference,
  type DocumentData,
  type DocumentSnapshot,
  type Query,
  type QuerySnapshot,
  onSnapshot,
  type Unsubscribe,
} from 'firebase/firestore';

export function snapshotSubscribeDoc(
  ref: DocumentReference<DocumentData>,
  label: string,
  onData: (snapshot: DocumentSnapshot<DocumentData>) => void,
  onError?: (error: Error) => void,
): Unsubscribe {
  return onSnapshot(
    ref,
    (snapshot) => onData(snapshot),
    (error) => {
      console.error(`[${label}]`, error);
      onError?.(error);
    },
  );
}

export function snapshotSubscribeQuery(
  q: Query<DocumentData>,
  label: string,
  onData: (snapshot: QuerySnapshot<DocumentData>) => void,
  onError?: (error: Error) => void,
): Unsubscribe {
  return onSnapshot(
    q,
    (snapshot) => onData(snapshot),
    (error) => {
      console.error(`[${label}]`, error);
      onError?.(error);
    },
  );
}
